import { render } from "./FilterButtons.vue?vue&type=template&id=4de13e99"
import script from "./FilterButtons.vue?vue&type=script&lang=js"
export * from "./FilterButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__